import { reservationsWatcher } from './containers/Booking/services/saga';

export const managerModuleSaga = [reservationsWatcher];
